
import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { configs } from '../configs/app.config';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-card-component',
  templateUrl: './card-component.component.html',
  styleUrls: ['./card-component.component.scss']
})
export class CardComponentComponent {

  @HostListener('click', ['$event']) onClick(event: any) {
    if (event.target.classList.contains('popup-bg')) {
      this.globalService.showTrue = true;
      this.globalService.showPopUp = "";
      document.body ? document.body.classList.remove('no-scroll') : '';
    }
  }


  @Input() index: number;
  @Input() listData: any;
  @Input() pageTab: any = 0;
  @Input() cardName: any;
  @Input() units:any;
  @Output() valueChange = new EventEmitter();


  public _listData: any;
  public kpiValueListArray: Array<any> = [];
  public currentUrl: any = '';
  public currentUrlCheck: boolean = false;
  public cardType: Object = configs['cardType'];
  public currentPopUp: number;
 
  constructor(public globalService: GlobalService) {

    this.currentUrl = window.location.href;
    if (this.currentUrl.indexOf('benchmarking') > -1) {
      this.currentUrlCheck = true;
    }
  }


  ngAfterViewInit() {
    this.currentUrlCheck = true;

  }
  forPopupOpen(index) {
    this.currentPopUp = index;
    document.body ? document.body.classList.add('no-scroll') : '';
  }

  formatsDateTest: string = 'dd/MM/yy';

  ngDoCheck() {
    if (this.listData && this.listData != this._listData) {
      this._listData = this.listData;
      if (this._listData && this._listData['scoreName'] && (this.listData['scoreName'].length > 0) && this._listData[this._listData['scoreName']] && this._listData[this._listData['scoreName']].length > 0 && this._listData[this._listData['scoreName']][0]['subScores']) {
        this.kpiValueListArray = this._listData[this._listData['scoreName']][0]['subScores'];
      }
    }
  }

  closePopUp() {
    this.currentPopUp = null;
  }
  valueChangeEvent(event) {
    this.valueChange.emit('adDadDddD');
  }


}

